var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"TipCreate"}},[_c('ProductForm',{attrs:{"submitForm":_vm.addRow,"buttonText":"Guardar","hasReset":"true","hasTips":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }